import Loadable from '@react-loadable/revised';

const LoadableCaptionDetail = Loadable({
    loader: () => import('./CaptionDetail'),
    loading: () => null
});

export default LoadableCaptionDetail;
